import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const NaviIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <g id="Icon / Navi" clipPath="url(#clip0_12386_16153)">
                <path
                    id="Vector"
                    d="M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM11.6667 14.1667H5.83333V12.5H11.6667V14.1667ZM14.1667 10.8333H5.83333V9.16667H14.1667V10.8333ZM14.1667 7.5H5.83333V5.83333H14.1667V7.5Z"
                    fill={props.htmlColor ?? '#A7A9AC'}
                />
            </g>
            <defs>
                <clipPath id="clip0_12386_16153">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
